import React, {Fragment} from "react";
import Validator from "../../../utils/Validator";
import InputErrorMessage from "../InputErrorMessage";

function CompanyInitialForm({offerWithCalculation, formValidator, onChange}) {

    const companyValueChangeHandler = (event) => {
        const {name, value} = event.target;
        onChange({...offerWithCalculation, [name]: value});
    }

    return (
        <Fragment>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="nip">NIP</label>
                <input type="text"
                       id="nip"
                       ref={formValidator.register({
                           required: true,
                           pattern: /[0-9]{10}/,
                           maxLength: 10,
                           validate: value => Validator.validateNip(value)
                       })}
                       name="nip"
                       value={offerWithCalculation.nip}
                       onChange={companyValueChangeHandler}
                       placeholder="Np. 1234567890 (10 cyfr)"/>
                <InputErrorMessage error={formValidator.errors.nip} message="Podaj poprawny numer NIP"/>
            </div>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="email">Adres e-mail</label>
                <input type="email"
                       id="email"
                       ref={formValidator.register({required: true})}
                       name="email"
                       value={offerWithCalculation.email}
                       onChange={companyValueChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["email"]} message="Podaj poprawny adres e-mail"/>
            </div>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="phoneNumber">Nr telefonu</label>
                <input type="text"
                       id="phoneNumber"
                       ref={formValidator.register({
                           required: true,
                           pattern: /[0-9]{9}/,
                           maxLength: 9
                       })}
                       name="phoneNumber"
                       value={offerWithCalculation.phoneNumber}
                       onChange={companyValueChangeHandler}
                       placeholder="Np. 753421869 (9 cyfr)"/>
                <InputErrorMessage error={formValidator.errors["phoneNumber"]} message="Podaj poprawny numer telefonu"/>
            </div>
        </Fragment>
    );
}

export default CompanyInitialForm;